import {store, history} from './store'

export default store
export {store, history}



// WEBPACK FOOTER //
// src/store/index.js